import { useEffect, useState } from "react";
import { API_STATUS } from "../../constants";
import { GetApMessage } from "../../apis/user/get_ap_message";
import GetDate from "../../utils/getdate";
import { SendAppMessage } from "../../apis/user/send_app_message";
import { UpdateMreadCount } from "../../apis/user/update_mread_count";
import { ApprochMsgNote } from "../../apis/notification/approach_msg_note";

export default function ApproachMessage({ AppData, setMcount }) {
    const [msgApi, setMsgApi] = useState(API_STATUS);
    const [sendApi, setSendApi] = useState(API_STATUS);
    const [MsgData, setMsgData] = useState([]);
    const [loginId, setLoginId] = useState('');
    const [MsgTxt, setMsgTxt] = useState('');
    const [toUser, setToUser] = useState('');
    const [unreadApi, setUnreadApi] = useState(API_STATUS);

    useEffect(() => {
        const userCode = sessionStorage.getItem('USER_CODE');
        setLoginId(userCode);
        if (userCode === AppData['clientId']) {
            setToUser(AppData['userId']);
        } else {
            setToUser(AppData['clientId']);
        }
    }, []);

    useEffect(() => {
        GetApMessage(AppData['id'], setMsgApi);
    }, []);

    useEffect(() => {
        if (!msgApi.isError && !msgApi.isLoader && msgApi.data != null) {
            if (msgApi.data.status === 1) {
                setMsgData(msgApi.data.data);
            }
            UpdateMreadCount(AppData['id'], setUnreadApi);
            setMcount(0);
        }
    }, [msgApi]);

    useEffect(() => {
        if (!sendApi.isError && !sendApi.isLoader && sendApi.data != null) {
            if (sendApi.data.status === 1) {
                setMsgData(sendApi.data.data);
            }
        }
    }, [sendApi]);

    const sendMsg = () => {
        if (MsgTxt !== "") {
            let body = { 'mfrom': loginId, 'mto': toUser, 'msg': MsgTxt, 'aid': AppData['id'] };
            SendAppMessage(body, setSendApi);
            ApprochMsgNote(body);
        }
        setMsgTxt('');
    }

    useEffect(() => {
        const interval = setInterval(() => {
            GetApMessage(AppData['id'], setMsgApi);
        }, 10000);
        return () => clearInterval(interval);
    }, []);

    return <div className="bg-white mt-5">
        <div className="w-full p-5 py-10 overflow-y-auto  md:h-[calc(100vh-140px)] h-[calc(100vh-250px)]">
            {
                MsgData.length > 0 &&

                <div className="text-sm font-medium space-y-6">
                    {

                        MsgData.map((e, i) =>
                            <div>
                                {
                                    e.mfrom === loginId &&
                                    <div className="flex gap-2 flex-row-reverse items-end">
                                        {/* <img src="assets/images/avatars/avatar-3.jpg" alt="" className="w-4 h-4 rounded-full shadow" /> */}
                                        <div className="px-4 py-2 rounded-[20px] max-w-sm bg-gradient-to-tr from-sky-500 to-blue-500 text-white shadow" style={{ backgroundColor: '#3b82f6' }}>  {e.msg} <br /> <span style={{ fontSize: 11, color: '#303030' }}>{GetDate(e.date)}</span> </div>
                                    </div>
                                }
                                {
                                    e.mfrom !== loginId &&
                                    <div className="flex gap-3">
                                        {/* <img src="assets/images/avatars/avatar-2.jpg" alt="" className="w-9 h-9 rounded-full shadow" /> */}
                                        <div className="px-4 py-2 rounded-[20px] max-w-sm bg-secondery">  {e.msg} <br /> <span style={{ fontSize: 11 }}>{GetDate(e.date)}</span> </div>
                                    </div>
                                }

                            </div>
                        )
                    }


                </div>
            }


        </div>
        <div className="flex items-center md:gap-4 gap-2 md:p-3 p-2 overflow-hidden">

            <div className="relative flex-1">
                <textarea
                    value={MsgTxt}
                    onChange={(v) => setMsgTxt(v.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' && !e.shiftKey) {
                            e.preventDefault();
                            sendMsg();
                        }
                    }}
                    placeholder="Write your message"
                    rows="1"
                    className="w-full resize-none bg-secondery rounded-full px-4 p-2"
                />

                <button
                    onClick={sendMsg}
                    type="button" className="bg-blue-500 text-white shrink-0 p-1.5 pl-3 pr-3 absolute right-0.5 top-0" style={{ borderRadius: 25 }}>
                    <i class="fa fa-paper-plane" aria-hidden="true"></i>
                </button>

            </div>

        </div>
    </div>


}